module.exports = __webpack_public_path__ + "static/assets/471c65f97eb61d45e0f31bfea19b13ca.png";